<template>
  <card-collapsable
    headerClass="yellow darken-2 white--text"
    dialogClass="poker"
    :dialogProp="dialog"
  >
    <!-- :collapsed="collapsed" -->

    <!-- always visible -->
    <template #visible>
      <progress-countdown
        v-show="asta_settings.timeout_s"
        ref="timer_speaker"
        :time="asta_settings.timeout_s"
        name="poker"
        @timeover="timeoverSpeaker"
        @timeStep="setSpeakerTimeLeft"
      ></progress-countdown>
    </template>

    <!-- card-title -->
    <template #title>
      {{
        migliore_offerta.vincitore ? "Vuoi rilanciare?" : "Vuoi fare offerta?"
      }}
    </template>

    <!-- card-body -->
    <template #body>
      <calciatore-battuto
        :id="calciatoreInAsta"
        v-if="asta_round && calciatoreInAsta"
        xLarge
      ></calciatore-battuto>

      <div class="text-center">
        <!-- migliore offerta corrente-->
        <squadra-offerta
          :offerta="migliore_offerta.offerta"
          :uid="migliore_offerta.vincitore"
          :ifNoOfferta="'Nessuna offerta'"
          class="mt-4"
          variant="horizontal"
          creditiGlow
        ></squadra-offerta>
      </div>
      <div class="d-flex justify-center flex-wrap pa-3">
        <!-- +1 -->
        <v-btn
          v-if="migliore_offerta.vincitore"
          depressed
          rounded
          color="primary"
          class="ma-1"
          @click="setRilancio(1)"
          >+1</v-btn
        >

        <!-- +5 -->
        <v-btn
          depressed
          rounded
          color="primary"
          class="ma-1"
          @click="setRilancio(maxRilancio)"
          v-if="migliore_offerta.vincitore && maxRilancio > 1"
        >
          +{{ maxRilancio }}
        </v-btn>

        <!-- 1 -->
        <v-btn
          v-if="!migliore_offerta.vincitore"
          depressed
          rounded
          color="primary"
          class="ma-1"
          @click="setOffertaCustom(minOfferta)"
          >{{ minOfferta }}</v-btn
        >

        <!-- ... -->
        <v-btn
          depressed
          rounded
          color="primary"
          class="ma-1"
          id="numpad-btn"
          v-show="maxOfferta > 1"
          @click="showNumpad()"
          >...</v-btn
        >
        <!-- passo -->
        <v-btn
          depressed
          rounded
          class="ma-1"
          color="primary"
          text
          @click="setPasso"
          >Passo</v-btn
        >
      </div>
    </template>

    <!-- footer -->
    <template #actions>
      <div v-if="squadra(user_uid)" class="pa-4">
        <squadra-info-panel :id_squadra="user_uid"></squadra-info-panel>
      </div>
      <div v-if="my_squadra" class="px-4 pb-4">
        <v-list
          :class="{ 'nice-scroll': !is_mobile }"
          class="recycle-scroller navy darken-2 pb-2 rounded"
        >
          <div class="text-center py-2">Pianificazione ruolo</div>
          <asta-consiglio></asta-consiglio>
          <asta-slot
            v-for="(slotData, slot, i) in myPlan[ruolo_abc]"
            :key="ruolo_abc + '_' + slot"
            :ruolo_abc="ruolo_abc"
            :iSlot="slot"
            :i="i"
          ></asta-slot>
        </v-list>
      </div>
    </template>
  </card-collapsable>
</template>

<script>
import db from "../../js/db";

import mixins from "../../js/mixins";
import toast from "../../js/toast";
import astaPokerActionsMixin from "../../js/mixins/astaPokerActionsMixin";

import SquadraInfoPanel from "../common/SquadraInfoPanel";
import ProgressCountdown from "../common/ProgressCountdown";
import CalciatoreBattuto from "../common/CalciatoreBattuto";
import CardCollapsable from "../common/CardCollapsable";
import SquadraOfferta from "../common/SquadraOfferta";
import AstaSlot from "../AstaSlot";
import AstaConsiglio from "../AstaConsiglio";

export default {
  name: "asta-poker",
  mixins: [mixins, toast, astaPokerActionsMixin],
  components: {
    ProgressCountdown,
    CalciatoreBattuto,
    SquadraInfoPanel,
    CardCollapsable,
    SquadraOfferta,
    AstaSlot,
    AstaConsiglio
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    console.log("--> AstaPoker ready.");
    db.on("numpadSubmitted", this.setOffertaCustom);
    db.on("speaker", this.handleDialog);
    db.on("showSpeaker", this.show);
    db.on("dismissSpeaker", this.dismiss);
  },
  destroyed() {
    console.log("<-- AstaPoker destroyed.");
    db.off("numpadSubmitted", this.setOffertaCustom);
    db.off("speaker", this.handleDialog);
    db.off("showSpeaker", this.show);
    db.off("dismissSpeaker", this.dismiss);
  },
  watch: {
    dialog(val) {
      if (val) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    },
  },
  methods: {
    dismissPokerAction() {
      this.dismiss();
    },
    show() {
      this.action = false;
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
      this.hideNumpad();
    },
    handleDialog() {
      if (
        this.asta_round.speaker == this.user_uid &&
        this.migliore_offerta.vincitore != this.user_uid &&
        this.running
      ) {
        this.show();
      } else {
        this.dismiss();
      }
    },
    startTimer() {
      this.$refs["timer_speaker"].start();
    },
    stopTimer() {
      this.$refs["timer_speaker"].stop();
    },
    timeoverSpeaker() {
      if (this.action) return;

      this.setPasso();
    },
    setSpeakerTimeLeft(timeLeft) {
      db.setSpeakerTimeLeft(timeLeft);
    },
  },
};
</script>
<style>
</style>
